"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrollmentHelperApi = void 0;
class EnrollmentHelperApi {
    addressSuggestions(requestParameters) {
        const addresses = [
            {
                country: 'United States',
                lineOne: '',
                lineTwo: '',
                locality: '',
                subdivision: 'Texas',
                postalCode: '',
            },
        ];
        return Promise.resolve(addresses);
    }
    updateApplicantInfo(requestParameters) {
        return Promise.resolve('Applicant info updated');
    }
    applicantInfoByBiographics(requestParameters) {
        const applicantInfo = {
            enrollmentId: '',
            name: {
                firstName: requestParameters.firstName,
                middleName: requestParameters.middleName,
                noMiddleName: (requestParameters.middleName == null),
                lastName: requestParameters.lastName,
                suffix: 'junior',
            },
            determinationStatus: 'processing',
            contact: {
                email: 'example@example.com',
                emailVerification: 'example@example.com',
                phoneNumber: '1.5125551234',
                preferredMethodOfContact: 'text',
                optIntoReceivingTexts: true,
            },
            clearPromotionsOptIn: true,
        };
        return Promise.resolve(applicantInfo);
    }
    ktnLookupByApplicationId(requestParameters) {
        const applicantInfo = {
            name: {
                firstName: 'Jane',
                middleName: 'Jo',
                noMiddleName: false,
                lastName: 'Smith',
                suffix: 'junior',
            },
            determinationStatus: 'processing',
            ktn: 'XXXXXXXXXXXXX',
            expirationDate: new Date(),
        };
        return Promise.resolve(applicantInfo);
    }
    ktnLookupByBiographics(requestParameters) {
        const applicantInfo = {
            name: {
                firstName: requestParameters.firstName,
                middleName: requestParameters.middleName,
                noMiddleName: (requestParameters.middleName == null),
                lastName: requestParameters.lastName,
                suffix: 'junior',
            },
            determinationStatus: 'processing',
            ktn: 'XXXXXXXXXXXXX',
            expirationDate: new Date(),
        };
        return Promise.resolve(applicantInfo);
    }
    clearPromotionsOpt(requestParameters) {
        return Promise.resolve('Accepted');
    }
}
exports.EnrollmentHelperApi = EnrollmentHelperApi;
//# sourceMappingURL=EnrollmentHelperApi.js.map